// extracted by css-extract-rspack-plugin
export default {"cell-container":"cell-container-gic0Dr","cellContainer":"cell-container-gic0Dr"};